import { useSettings } from "../../hooks/collections/useSettings";
import { useEffect, useState } from "react";
import { useLoader } from "../../@shared/hooks/useLoader";
import QuillRenderer from "../../@core/components/QuillRenderer";

export const ToSPage = () => {
  const { getToS } = useSettings({ loadData: false });
  const [isLoading, setIsLoading] = useState(true);
  const [content, setContent] = useState<string>("");

  const loader = useLoader();

  const getData = async () => {
    loader.start();
    try {
      const data: any = await getToS();
      setContent(data?.content || "");
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
      loader.stop();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-dvh py-2 max-w-5xl mx-auto px-4">
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen py-2 max-w-5xl mx-auto px-4">
      <QuillRenderer content={content}/>
    </div>
  );
};
